import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { newsChannelData } from "../utils/newsChannel";
import ReactGA from 'react-ga4'
import { captureEvent } from "../services/analytics/eventCapture";


const News = () => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/news", title: "News | Chimera | Euler Motors" });
    }, [])
    
    return (
        <div className="w-full h-[100vh] screen-background flex flex-col">
                <div className="text-[#F8F9FA] font-[500] text-[32px] px-5 py-4">News</div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6 px-5 gap-x-[20px] gap-y-[24px] text-white justify-center scroll-container overflow-y-auto">
                    {
                        newsChannelData?.map((channel) => (
                            <Link 
                              to={`https://www.youtube.com/@${channel?.channelId}`} 
                              onClick={() => captureEvent("News", "Channel_Click", channel?.channleName)} 
                              className="flex flex-col items-center bg-[#2E3134] py-3 rounded-xl"
                            >
                                <div>
                                    <img src={channel?.channelLogo} className="rounded-full" alt="channel-logo" width={160} height={160}/>
                                </div>

                                <div className="text-[24px] font-[500] pt-3">
                                    {channel?.channleName}
                                </div>
                            </Link>
                        ))
                    }
                </div>
        </div>
    )
}

export default News;